import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Button, Modal, ModalBody, ModalFooter } from 'chaoskit/src/components';
import useUpdateEffect from 'react-use/lib/useUpdateEffect';

import { Data, Icon } from '../../components';
import Author from '../global/Author';
import SocialGroup from '../global/SocialGroup';

const Talk = ({
  authorComponents,
  data,
  activeTalk,
  handleCloseTalkModal,
  location,
}) => {
  const [talkUrlCopied, setTalkUrlCopied] = useState(false);

  const videoShareUrl = `${location.origin}${location.pathname}?video=${data.youtubeId}`;

  const handleTalkUrlCopy = () => {
    setTalkUrlCopied(true);
  };

  useUpdateEffect(() => {
    if (talkUrlCopied) {
      setTimeout(() => {
        setTalkUrlCopied(false);
      }, 2500);
    }
  }, [talkUrlCopied]);

  return (
    <Fragment>
      <div className="community__talk-wrapper">
        <div
          className="community__talk"
          role="dialog"
          style={{
            backgroundImage: `url('https://img.youtube.com/vi/${data.youtubeId}/maxresdefault.jpg')`,
          }}
        >
          <div className="community__talk-top">
            <Author name={data.presenter} components={authorComponents} />
          </div>
          <div className="community__talk-bottom">{data.title}</div>
        </div>
      </div>
      <Modal
        open={activeTalk === data.youtubeId}
        size="large"
        onOutsideModalClick={handleCloseTalkModal}
      >
        <ModalBody className="community__talkModal-body">
          <div className="community__talkModal-author-wrapper">
            <h4 className="u-textCenter u-textLeft@medium u-mb--remove">
              <Data>{data.title}</Data>
            </h4>
            <Author
              className="u-flexCenter u-flexLeft@medium u-flexItemNone"
              name={data.presenter}
              components={['avatar', 'name', 'position']}
            />
          </div>
          <div className="community__talkModal-video">
            <iframe
              title="Video"
              src={`https://www.youtube.com/embed/${data.youtubeId}?modestbranding=1&rel=0&showinfo=0&autohide=1&autoplay=1`}
              border="0"
              allow="autoplay"
            />
          </div>
        </ModalBody>
        <ModalFooter className="community__talkModal-footer">
          <div className="community__talkModal-social">
            <SocialGroup
              networks={[
                {
                  service: 'twitter',
                  url: `https://twitter.com/intent/tweet?text=${data.title}&url=${videoShareUrl}`,
                  title: 'Share on Twitter',
                },
                {
                  service: 'facebook',
                  url: `https://www.facebook.com/sharer.php?u=${videoShareUrl}`,
                  title: 'Share on Facebook',
                },
                {
                  service: 'linkedin',
                  url: `https://www.linkedin.com/shareArticle?title=${data.title}&url=${videoShareUrl}`,
                  title: 'Share on LinkedIn',
                },
              ]}
            />
          </div>
          <CopyToClipboard text={videoShareUrl} onCopy={handleTalkUrlCopy}>
            <Button size="small" type="default" disabled={talkUrlCopied}>
              {talkUrlCopied ? (
                'Copied'
              ) : (
                <Fragment>
                  <Icon icon="copy" /> Copy Link
                </Fragment>
              )}
            </Button>
          </CopyToClipboard>
        </ModalFooter>
      </Modal>
    </Fragment>
  );
};

Talk.propTypes = {
  activeTalk: PropTypes.string,
  handleCloseTalkModal: PropTypes.func.isRequired,
  authorComponents: PropTypes.array.isRequired,
  data: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
};

export default Talk;
